import "../css/style.css";
// import { Modal, Tabs, Carousel } from 'flowbite';
import { scroller } from "./modules/smooth";
import init from "./init";
((ready) => {
    if (document.readyState !== "loading") {
        ready();
    } else {
        document.addEventListener("DOMContentLoaded", ready);
    }
})(() => {
    init(document);
});

/**
 * Alpine JS
 * Best to put it last so that all other potential JS is available
 * when components start getting initialized.
 */
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import { videoModal } from "./modules/alpineModules";
Alpine.plugin(focus);
Alpine.plugin(videoModal);
if (!window.Alpine) {
    window.Alpine = Alpine;
    Alpine.start();
}

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}
